import {Permission} from "./Permission";
import {autoWebViewJs} from "../AutoWebViewJs";
import {PermissionAskUi} from "./PermissionAskUi";
import {PermissionAskUiConf, PermissionConf} from "./PermissionInterfaces";
import i18n from "i18next";
import {Manifest} from "./Manifest";
import { getTrans } from "./i18n";
// import { storageKeys } from "@droid/data";

/**
 * ask back data
 * class A11yServiceLiveInfo {
 *     var hasPermission = false
 *     var hasService = false
 *     var isAlive = false
 *     var pingTime = 0L
 *     var test = "abc"
 * }
 */
function callback(isOk:boolean, rejectMsg:string):void{

}


function createPermissionConf(askUi:PermissionAskUi){
    let conf:PermissionConf = {
        askUi: askUi, callback,  permissionId: 0,
        scripts: {
            ask: {
                script:"",
                isRunner:false
            },
            check: {
                script:``,
                isRunner:false
            }
        },
        listenResume:true,
    }
    return conf
}

function createAskUi(){
    const t = getTrans()
    let conf:PermissionAskUiConf = {
        cancelButtonText: t("A11yPermission.cancel"),
        checkBoxText: t("A11yPermission.checkBoxText"),
        hasCheckBox: true,
        okButtonText: t("A11yPermission.ok"),
        // storageKey: storageKeys.permissions.a11y.showAsk,
        storageKey: 'storageKeys.permissions.a11y.showAsk',
        text: t("A11yPermission.content"),
        title:t("A11yPermission.title")
    }
    let askUi = new PermissionAskUi();
    askUi.conf = conf;
    return askUi
}

export function createA11yPermission(){
    let askUi = createAskUi();
    let permissionConf = createPermissionConf(askUi)
    let permission = new A11yPermission();
    permission.conf = permissionConf
    return permission;
}

interface IA11yResult{
    hasPermission:boolean
}

export class A11yPermission extends Permission{
    constructor() {
        super();
        this.androidPermissionList = [
            Manifest.Permission.BIND_ACCESSIBILITY_SERVICE
        ]
    }
    runCheck(){
        let {print, error, warn, logger} = this.logger.sub(false, "fn_ask");
        let res = autoWebViewJs.onCallGetA11yServiceLiveInfo<IA11yResult>();
        let {errMsg, javaResultData: data} = res;
        if(errMsg){
            error(errMsg)
            error(errMsg);
            return undefined
        }
        print("data2 is", res);
        // print("data3 is", res?.hasPermission);
        return data?.hasPermission
    }
    ask(){
        autoWebViewJs.onCallOpenA11yPermission()
    }
}